export default __webpack_public_path__ + "static/media/FEES STRUCTURE 9.8dd020e6.pdf";